// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"488":"75d3050d","687":"491815fc","754":"df90d811"}[chunkId] + ".css";
};